/* i18n del dashboard público (SOLO esta vista se traduce; el admin queda en español).
   El idioma se persiste en localStorage y se cambia con el toggle ES/EN del header. */

const LANG_KEY = 'boston_dashboard_lang'

export const DASHBOARD_TEXTS = {
  es: {
    // Header / shell
    agencyActive: 'Agencia activa',
    footerPowered: 'Boston Scripts · potenciado con IA',
    floatOpen: 'Crear script con IA',
    floatClose: 'Cerrar constructor',
    reviewHistoryTitle: 'Historial enviado a Dev',
    reviewHistorySubtitle: 'Seguimiento de tus envios y estados recientes.',
    reviewHistoryEmpty: 'Aun no hay envios a Revision Dev.',
    // Grid
    searchPlaceholder: 'Buscar script por nombre',
    clearSearch: 'Limpiar búsqueda',
    script: 'script',
    scripts: 'scripts',
    noResults: 'No se encontraron scripts para «{q}».',
    loadingScripts: 'Cargando scripts disponibles...',
    tokenRequired: 'Token requerido.',
    noScripts: 'No hay scripts disponibles para este token.',
    openScript: 'Abrir «{name}»',
    // Repo
    repoTitle: 'Repositorio',
    repoSearchPlaceholder: 'Buscar repositorio',
    repoNoResults: 'No se encontraron repositorios para «{q}».',
    repoEmpty: 'Aún no tenés scripts en tu repositorio.',
    resendDev: 'Reenviar a Dev',
    resendBusy: 'Enviando…',
    resendConfirm: 'Se desactivará «{name}» y volverá a Revisión Dev. ¿Continuar?',
    resendOk: '«{name}» fue desactivado y reenviado a Revisión Dev.',
    loadingList: 'Cargando scripts...',
    view: 'Ver',
    preview: 'Vista previa',
    readMore: 'leer más…',
    readLess: 'leer menos',
    createdAt: 'Creado',
    updatedAt: 'Modif.',
    distribute: 'Distribuir',
    redistribute: 'Redistribuir',
    distributing: 'Distribuyendo...',
    remove: 'Eliminar',
    close: 'Cerrar',
    cancel: 'Cancelar',
    // Modal distribuir
    distTitle: 'Distribuir «{name}»',
    distHelp: 'Elegí a qué PCCs y usuarios de tu Parent PCC {pcc} distribuir.',
    pccs: 'PCCs',
    users: 'Usuarios',
    usersCount: 'usuarios',
    assigned: 'Asignado',
    onlyPcc: 'Aplicar solo este PCC',
    onlyPccHelp: 'Se dará acceso a todo el PCC seleccionado.',
    pickUsersHelp: 'Seleccioná los usuarios que tendrán acceso a esta distribución.',
    pickAtLeastOne: 'Seleccioná al menos un usuario.',
    pickPccFirst: 'Seleccioná un PCC para ver sus usuarios.',
    noPccs: 'Sin PCCs.',
    noUsersPcc: 'Sin usuarios para este PCC.',
    loadingPccs: 'Cargando PCCs...',
    loadingUsers: 'Cargando usuarios...',
    distBtn: 'Distribuir ({n})',
    // Modal eliminar
    deleteTitle: 'Eliminar «{name}»',
    deleteBody: 'Se va a eliminar el script del repositorio y se le va a quitar a todos los usuarios y PCCs a los que fue distribuido dentro de tu Parent PCC {pcc}.',
    deleteIrreversible: 'Esta acción no se puede deshacer.',
    deleteConfirm: 'Eliminar definitivamente',
    deleting: 'Eliminando...',
    // Panel IA
    panelTitle: 'Constructor de scripts',
    panelSub: 'Subí un archivo Sabre o describí el script. La IA primero te dice cómo lo interpretó; corregila conversando hasta que esté bien y recién ahí genera el script.',
    step1: 'Desde archivo',
    step1Hint: 'Subí uno o varios .sst / .ssc y la IA los analiza juntos.',
    chooseFile: 'Elegir archivo(s)',
    noFile: 'Ningún archivo seleccionado',
    removeFile: 'Quitar',
    interpretScript: 'Interpretar script',
    interpreting: 'Interpretando...',
    viewAnalysis: 'Ver análisis',
    depsWarning: 'Este script llama a: {deps}. Subí también ese/esos script(s) para analizarlos todos juntos.',
    alertsChip: '{n} alerta(s) al usuario',
    step2: 'Por descripción',
    step2Hint: 'Contale a la IA qué script necesitás. Primero te muestra cómo lo entendió.',
    descPlaceholder: 'Ej: un script que cargue remarks de hotel con número de segmento, tarifa y forma de pago…',
    interpretAI: 'Interpretar con IA',
    // Chat
    chatTitle: '🧠 Así lo interpretó el agente',
    chatFile: 'Archivo(s): {name}',
    chatDesc: 'Descripción libre',
    agent: 'Agente',
    you: 'Vos',
    applyingFix: 'Aplicando tu corrección…',
    chatPlaceholder: '¿Algo está mal? Decile al agente qué corregir…',
    sendFix: 'Corregir',
    confirmGenerate: '✓ Es correcto — Generar script',
    generating: '⏳ Generando…',
    discard: 'Descartar',
    stop: '■ Detener',
    stopTitle: 'Detener el proceso de IA',
    sscPartial: '⚠ Interpretado desde el compilado (.ssc): el flujo puede ser parcial — corregí lo que falte.',
    loaderInterpreting: 'Interpretando lo que pediste...',
    loaderApplying: 'Aplicando tu corrección...',
    loaderGenerating: 'Generando el script...',
    // Preview / publicación
    previewTitle: 'Vista previa funcional',
    sendReview: 'Enviar a Revisión Dev',
    sending: 'Enviando...',
    publishForMe: 'Publicar para mí',
    publishing: 'Publicando para mí...',
    reviewModalTitle: 'Enviar a Revisión Dev',
    reviewModalHelp: 'Describí qué querés que revise el equipo Dev antes de guardar la revisión.',
    reviewReason: 'Motivo de envío a revisión',
    reviewPlaceholder: 'Describí qué querés que revise el equipo Dev...',
    confirmSend: 'Confirmar envío',
    published: 'fue publicado para tu usuario',
    inReview: 'quedó en Revisión Dev',
    open: 'Abrir',
    generateAnother: 'Generar otro',
    draftsTitle: 'Scripts generados (sin enviar)',
    draftHint: 'Abrí "Ver preview" para aprobar (Publicar) o enviar a Revisión Dev.',
    viewPreview: 'Ver preview',
  },
  en: {
    agencyActive: 'Active agency',
    footerPowered: 'Boston Scripts · powered by AI',
    floatOpen: 'Create script with AI',
    floatClose: 'Close builder',
    reviewHistoryTitle: 'Dev review history',
    reviewHistorySubtitle: 'Track your recent sends and statuses.',
    reviewHistoryEmpty: 'No Dev Review sends yet.',
    searchPlaceholder: 'Search script by name',
    clearSearch: 'Clear search',
    script: 'script',
    scripts: 'scripts',
    noResults: 'No scripts found for “{q}”.',
    loadingScripts: 'Loading available scripts...',
    tokenRequired: 'Token required.',
    noScripts: 'No scripts available for this token.',
    openScript: 'Open “{name}”',
    repoTitle: 'Repository',
    repoSearchPlaceholder: 'Search repository',
    repoNoResults: 'No repositories found for “{q}”.',
    repoEmpty: "You don't have scripts in your repository yet.",
    resendDev: 'Resend to Dev',
    resendBusy: 'Sending…',
    resendConfirm: '«{name}» will be deactivated and sent back to Dev review. Continue?',
    resendOk: '«{name}» was deactivated and resent to Dev review.',
    loadingList: 'Loading scripts...',
    view: 'View',
    preview: 'Preview',
    readMore: 'read more…',
    readLess: 'read less',
    createdAt: 'Created',
    updatedAt: 'Updated',
    distribute: 'Distribute',
    redistribute: 'Redistribute',
    distributing: 'Distributing...',
    remove: 'Delete',
    close: 'Close',
    cancel: 'Cancel',
    distTitle: 'Distribute “{name}”',
    distHelp: 'Choose which PCCs and users of your Parent PCC {pcc} to distribute to.',
    pccs: 'PCCs',
    users: 'Users',
    usersCount: 'users',
    assigned: 'Assigned',
    onlyPcc: 'Apply to this PCC only',
    onlyPccHelp: 'Access will be granted to the whole selected PCC.',
    pickUsersHelp: 'Select the users that will get access to this distribution.',
    pickAtLeastOne: 'Select at least one user.',
    pickPccFirst: 'Select a PCC to see its users.',
    noPccs: 'No PCCs.',
    noUsersPcc: 'No users for this PCC.',
    loadingPccs: 'Loading PCCs...',
    loadingUsers: 'Loading users...',
    distBtn: 'Distribute ({n})',
    deleteTitle: 'Delete “{name}”',
    deleteBody: 'The script will be removed from the repository and revoked from every user and PCC it was distributed to within your Parent PCC {pcc}.',
    deleteIrreversible: 'This action cannot be undone.',
    deleteConfirm: 'Delete permanently',
    deleting: 'Deleting...',
    panelTitle: 'Script builder',
    panelSub: 'Upload a Sabre file or describe the script. The AI first tells you how it interpreted it; fix it by chatting and only then it generates the script.',
    step1: 'From file',
    step1Hint: 'Upload one or more .sst / .ssc files and the AI analyzes them together.',
    chooseFile: 'Choose file(s)',
    noFile: 'No file selected',
    removeFile: 'Remove',
    interpretScript: 'Interpret script',
    interpreting: 'Interpreting...',
    viewAnalysis: 'View analysis',
    depsWarning: 'This script calls: {deps}. Upload those script(s) too so they are analyzed together.',
    alertsChip: '{n} user alert(s)',
    step2: 'From description',
    step2Hint: 'Tell the AI which script you need. It first shows you how it understood it.',
    descPlaceholder: 'E.g.: a script that adds hotel remarks with segment number, fare and payment method…',
    interpretAI: 'Interpret with AI',
    chatTitle: '🧠 How the agent interpreted it',
    chatFile: 'File(s): {name}',
    chatDesc: 'Free description',
    agent: 'Agent',
    you: 'You',
    applyingFix: 'Applying your correction…',
    chatPlaceholder: 'Something wrong? Tell the agent what to fix…',
    sendFix: 'Send fix',
    confirmGenerate: '✓ Looks good — Generate script',
    generating: '⏳ Generating…',
    discard: 'Discard',
    stop: '■ Stop',
    stopTitle: 'Stop the AI process',
    sscPartial: '⚠ Interpreted from the compiled file (.ssc): the flow may be partial — fix anything missing.',
    loaderInterpreting: 'Interpreting your request...',
    loaderApplying: 'Applying your correction...',
    loaderGenerating: 'Generating the script...',
    previewTitle: 'Functional preview',
    sendReview: 'Send to Dev Review',
    sending: 'Sending...',
    publishForMe: 'Publish for me',
    publishing: 'Publishing for me...',
    reviewModalTitle: 'Send to Dev Review',
    reviewModalHelp: 'Describe what you want the Dev team to review before saving.',
    reviewReason: 'Reason for review',
    reviewPlaceholder: 'Describe what you want the Dev team to review...',
    confirmSend: 'Confirm send',
    published: 'was published for your user',
    inReview: 'is now in Dev Review',
    open: 'Open',
    generateAnother: 'Generate another',
    draftsTitle: 'Generated scripts (not sent)',
    draftHint: 'Open "View preview" to approve (Publish) or send to Dev Review.',
    viewPreview: 'View preview',
  },
}

export function getDashboardLang() {
  try {
    const value = window.localStorage.getItem(LANG_KEY)
    return value === 'en' ? 'en' : 'es'
  } catch (_) {
    return 'es'
  }
}

export function saveDashboardLang(lang) {
  try {
    window.localStorage.setItem(LANG_KEY, lang === 'en' ? 'en' : 'es')
  } catch (_) { /* sin persistencia */ }
}

export function makeT(lang) {
  const dict = DASHBOARD_TEXTS[lang] || DASHBOARD_TEXTS.es
  return function t(key, vars) {
    let text = dict[key] !== undefined ? dict[key] : (DASHBOARD_TEXTS.es[key] !== undefined ? DASHBOARD_TEXTS.es[key] : key)
    if (vars) {
      Object.keys(vars).forEach((name) => {
        text = text.split(`{${name}}`).join(String(vars[name]))
      })
    }
    return text
  }
}
